module.exports = __webpack_public_path__ + "img/2fed137b8e3c3a3149c2c88c48ea975c.png";